import React from 'react';
import PropTypes from 'prop-types';

// import { Button as rmwc_Button } from 'rmwc/Button';
// import { Ripple } from 'rmwc/Ripple';

import styled from 'styled-components';

// TODO:
// Make styled components for each theme

const propTypes = {
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    text: PropTypes.string,
    size: PropTypes.number,
    isShow: PropTypes.bool,
    theme: PropTypes.oneOf([
        'yellowBg',
        'yellowBorder',
        'whiteBorder',
    ]),
    isTextLowerCased: PropTypes.bool,
    containerStyle: PropTypes.object,
    buttonStyle: PropTypes.object,
    iconStyle: PropTypes.object,
    textStyle: PropTypes.object,
    className: PropTypes.string,
};
const defaultProps = {
    size: 32,
    isShow: true,
    theme: 'yellowBg',
};

const Container = styled.div`
  font-size: ${props => props.size}px;
`;

const Button = styled.button`
  background: ${props => {
    if (props.style && props.style.background) return props.style.background;
    if (props.theme === 'yellowBg') {
        return 'var(--accent-color)!important';
    } else if (
        props.theme === 'yellowBorder' ||
        props.theme === 'whiteBorder'
    ) return 'transparent'
    return '#fff';
}};
  color: ${props => props.style && props.style.color ? props.style.color : '#fff'};
  border: ${props => {
    let color;
    if (props.theme === 'yellowBorder') {
        color = 'var(--accent-color)';
    } else if (
        props.theme === 'whiteBorder'
    ) {
        color = '#fff';
    }
    return `0.175em solid ${color}`;
}};

  min-width: auto;
  width: ${props => (
    props.istexted
        ? 'auto'
        : '4em'
)};
  padding: ${props => (
    props.istexted
        ? '0 1.5em'
        : '0'
)};
  height: 4em;
  border-radius: 2em;
  font-size: inherit;
`;
const Icon = styled.i`
  font-size: 3em;
  color: ${props => {
    if (props.style && props.style.color) return props.style.color;
    if (
        props.theme === 'yellowBg' ||
        props.theme === 'whiteBorder'
    ) {
        return '#fff';
    } else if (props.theme === 'yellowBorder') return 'var(--accent-color)';
    return '#fff'
}};
`;

const Text = styled.span`
  color: ${props => {
    if (props.style && props.style.color) return props.style.color;
    if (
        props.theme === 'yellowBg' ||
        props.theme === 'whiteBorder'
    ) {
        return '#fff';
    } else if (props.theme === 'yellowBorder') {
        return 'var(--accent-color)';
    }
    return '#fff'
}};
  font-size: 1em;
  text-transform: ${props => props.isTextLowerCased
    ? 'lowercase'
    : 'none'
    };
`;

const FloatingActionButton = props => {

    const {
        onClick,
        iconName,
        text,
        isTextLowerCased,
        size,
        className,
        containerStyle,
        buttonStyle,
        iconStyle,
        textStyle,
        isShow,
        theme,
    } = props;

    if (!isShow) {
        return null;
    }
    return (
        <Container className={className} style={containerStyle} size={size}>
            {/*<Ripple>*/}
                <Button theme={theme} istexted={typeof text === 'string' && !!text ? text : undefined} onClick={onClick} style={buttonStyle}>
                    {
                        iconName
                            ? <Icon theme={theme} style={iconStyle} className="material-icons">{iconName}</Icon>
                            : <Text isTextLowerCased={isTextLowerCased} theme={theme} style={textStyle}>{text}</Text>
                    }
                </Button>
            {/*</Ripple>*/}
        </Container>
    )
};

FloatingActionButton.propTypes = propTypes;
FloatingActionButton.defaultProps = defaultProps;

export default FloatingActionButton;



// WEBPACK FOOTER //
// ./src/components/PoiDetailsView/Fab.jsx